// Presentation helpers for the tickets queue (spec 024 T7) — the kinds
// reportLesson.js, lessonLifecycle.js and createTicket.js raise.

// The three kinds the server writes today (reportLesson.js, lessonLifecycle.js,
// createTicket.js).
// An unknown kind renders as itself — never as a wrong friendly name.
const LABELS = {
  reported_lesson: "Reported lesson",
  unresolved_lesson: "Unresolved lesson",
  // createTicket.js (spec 032): the kind a person raises from Support.
  user_request: "Request",
};
export const kindLabel = (kind) => LABELS[kind] || kind;

// Firestore Timestamp, Date, or an ISO-ish string — same shapes Lessons.js's
// own parseDate and functions/lessonWindows.js's at() already handle.
export const toDate = (value) => {
  if (!value) return null;
  const date =
    typeof value.toDate === "function" ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDate = (value) => toDate(value)?.toLocaleString() || "-";

export const truncate = (text, max = 80) =>
  !text ? "-" : text.length > max ? `${text.slice(0, max)}…` : text;
